import { httpService } from "@/common/services/HttpService";
import { AdminReceipt, AdminReceiptListItem } from "@/common/models/Receipt";
import { PaginatedResponse } from "@/common/models/PaginatedResponse";

class ReceiptsService {
  async getReceipts(
    storeId: string | undefined | null,
    userId: string | undefined | null,
    from: string | undefined | null,
    to: string | undefined | null,
    offset: number,
    limit: number
  ): Promise<PaginatedResponse<AdminReceiptListItem>> {
    const { data } = await httpService.getInstance().get(`/api/v1/backoffice/admin/receipts`, {
      params: {
        storeId,
        userId,
        from,
        to,
        offset,
        limit,
      },
    });
    return data;
  }

  async getReceipt(receiptId: string): Promise<AdminReceipt> {
    const { data } = await httpService.getInstance().get(`/api/v1/backoffice/admin/receipts/${receiptId}`);
    return data;
  }
}

export const receiptsService = new ReceiptsService();
